import { InputTypes } from "../InputTypes";

export const Address = Object.freeze({
  name: {
    visibleName: "Nombre",
    type: InputTypes.TEXT_AREA,
  },
  address: {
    visibleName: "Dirección",
    type: InputTypes.TEXT_AREA,
  },
  city: {
    visibleName: "Ciudad",
    type: InputTypes.TEXT_AREA,
  },
  region: {
    visibleName: "Región",
    type: InputTypes.TEXT_AREA,
  },
  postal_code: {
    visibleName: "Código postal",
    type: InputTypes.NUMBER,
  },
});
